export const CONTESTANT = {
  name: "Arjun Mehta",
  avatar: "https://images.unsplash.com/photo-1527980965255-d3b416303d12?w=100&q=80",
  tracks: [
    { id:1, title:"Neon Horizon",   genre:"Electronic", status:"Under Review", score:null, date:"Apr 01, 2025", img:"https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=80&q=70" },
    { id:2, title:"Midnight Pulse", genre:"Electronic", status:"Scored",       score:87,   date:"Mar 22, 2025", img:"https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=80&q=70" },
    { id:3, title:"Lost in Static", genre:"Ambient",    status:"Scored",       score:74,   date:"Mar 10, 2025", img:"https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=80&q=70" },
  ],
};

export const JUDGE = {
  name: "Marcus Leon",
  avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&q=80",
  specialty: "Electronic & EDM",
};

export const QUEUE = [
  { id:1, title:"Neon Horizon",   artist:"Arjun Mehta",  genre:"Electronic", status:"pending", art:"https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=80&q=70" },
  { id:2, title:"City of Glass",  artist:"Priya Sharma", genre:"Electronic", status:"pending", art:"https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=80&q=70" },
  { id:3, title:"Bass Ritual",    artist:"DJ Kwame",     genre:"EDM",        status:"scored",  art:"https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=80&q=70" },
  { id:4, title:"Synthetic Rain", artist:"Mia Torres",   genre:"Ambient",    status:"pending", art:"https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=80&q=70" },
  { id:5, title:"Pulse Loop 009", artist:"Kenji Ito",    genre:"Electronic", status:"scored",  art:"https://images.unsplash.com/photo-1571327073757-71d13b1e23dc?w=80&q=70" },
  { id:6, title:"Euphoric Drift", artist:"Chloé Dupont", genre:"EDM",        status:"pending", art:"https://images.unsplash.com/photo-1501386761578-eac5c94b800a?w=80&q=70" },
];

export const ACTIVITY_CONTESTANT = [
  { icon:"🎵", bg:"rgba(255,60,95,.15)",  label:"Neon Horizon submitted",   detail:"awaiting judge review",  time:"2 hours ago" },
  { icon:"⭐", bg:"rgba(255,183,3,.15)",  label:"Midnight Pulse scored",    detail:"87/100 by Judge Marcus", time:"3 days ago"  },
  { icon:"💬", bg:"rgba(6,214,160,.15)",  label:"Feedback received",        detail:"on Lost in Static",      time:"5 days ago"  },
  { icon:"🏆", bg:"rgba(131,56,236,.15)", label:"Advanced to Semi-Finals",  detail:"Electronic category",    time:"1 week ago"  },
];

export const ACTIVITY_JUDGE = [
  { icon:"✅", bg:"rgba(6,214,160,.15)",  label:"Bass Ritual scored",       detail:"DJ Kwame — 91/100",      time:"1 hour ago"  },
  { icon:"✅", bg:"rgba(6,214,160,.15)",  label:"Pulse Loop 009 scored",    detail:"Kenji Ito — 78/100",     time:"4 hours ago" },
  { icon:"🔔", bg:"rgba(255,183,3,.15)",  label:"6 new tracks added",       detail:"to your review queue",   time:"Today"       },
  { icon:"📋", bg:"rgba(58,134,255,.15)", label:"Monthly report submitted", detail:"to Panel Committee",     time:"Yesterday"   },
];

export const SCORE_CRITERIA = ["Melody & Composition","Production Quality","Originality","Emotional Impact"];
export const SCORE_DIST     = [{ label:"Excellent",pct:32 },{ label:"Good",pct:45 },{ label:"Average",pct:15 },{ label:"Poor",pct:8 }];

export const TIMELINE = [
  { label:"Submissions Open", date:"Mar 1",  done:true,  active:false },
  { label:"Your Upload",      date:"Apr 1",  done:true,  active:false },
  { label:"Judging Period",   date:"May 1",  done:false, active:true  },
  { label:"Semi-Finals",      date:"May 20", done:false, active:false },
  { label:"Grand Finals",     date:"Jun 20", done:false, active:false },
];

export const GENRES     = ["Electronic & EDM","Rock & Metal","Hip-Hop & R&B","Jazz & Blues","Pop & Indie","Classical","World & Folk","Vocal"];
export const CATEGORIES = ["Open Category","Producer Spotlight","Vocalist Spotlight","Rookie Division","Collab Division"];

export const CONTESTANT_NAV = [
  { path:"/contestant/dashboard", icon:"🏠", label:"Dashboard" },
  { path:"/contestant/upload",    icon:"⬆️", label:"Upload Track" },
  { path:"/contestant/tracks",    icon:"🎵", label:"My Tracks" },
  { path:"/contestant/results",   icon:"🏆", label:"Results" },
  // { path:"/contestant/feedback",  icon:"💬", label:"Feedback", count:1 },
  { path:"/contestant/profile",   icon:"👤", label:"My Profile" },
];

export const JUDGE_NAV = [
  { path:"/judge/dashboard", icon:"🏠", label:"Dashboard" },
  { path:"/judge/examine",   icon:"🎧", label:"Examine Tracks", count:4 },
  { path:"/judge/scored",    icon:"✅", label:"Scored" },
  { path:"/judge/analytics", icon:"📊", label:"Analytics" },
  { path:"/judge/profile",   icon:"👤", label:"Profile" },
];